/**
 * results constants
 */
export const SET_RESULT = 'SET_RESULT';
